import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1547 L1920,1653.66667 L533.333333,1653.66667 L533.333333,1547 L1920,1547 Z M1920,1120.22667 L1920,1227 L533.333333,1227 L533.333333,1120.22667 L1920,1120.22667 Z M106.666667,267.042667 L106.666667,693.709333 L457.92,693.709333 L282.346667,518.136 L357.653333,442.616 L662.08,747.042667 L357.653333,1051.36267 L282.346667,975.949333 L457.92,800.269333 L0,800.269333 L0,267.042667 L106.666667,267.042667 Z M1066.66667,693.666667 L1066.66667,800.333333 L853.333333,800.333333 L853.333333,693.666667 L1066.66667,693.666667 Z M1493.33333,693.666667 L1493.33333,800.333333 L1280,800.333333 L1280,693.666667 L1493.33333,693.666667 Z M1920,693.666667 L1920,800.333333 L1706.66667,800.333333 L1706.66667,693.666667 L1920,693.666667 Z M1920,267 L1920,373.666667 L533.333333,373.666667 L533.333333,267 L1920,267 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveDownLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveDownLine, _Component);

  var _super = _createSuper(IconMoveDownLine);

  function IconMoveDownLine() {
    _classCallCheck(this, IconMoveDownLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveDownLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveDown",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMoveDownLine.displayName = "IconMoveDownLine";
  return IconMoveDownLine;
}(Component);

IconMoveDownLine.glyphName = 'move-down';
IconMoveDownLine.variant = 'Line';
IconMoveDownLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveDownLine;
export { IconMoveDownLine };